import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

// local components
import PaymentIntentsForm from './PaymentIntentsForm'

const PaymentMethodForm = props => {
  const {
    headerText, // via parent
    account // via query
  } = props

  return (
    <Box my={4}>
      {headerText && (
        <Typography pb={4} variant='h3' align='center'>
          {headerText}
        </Typography>
      )}
      <Card>
        <CardContent>
          <PaymentIntentsForm account={account} />
        </CardContent>
      </Card>
    </Box>
  )
}

export default PaymentMethodForm
